<template>
  <div class="CompProduct">
    <div class="CompProduct-top">
      <Row>
        <Col span="2"></Col>
        <Col span="20">
          <div class="CompProduct-top-content">
            <div class="CompProduct-top-content-left">
              <!-- <img src="../../assets/img/solution-content1.png" width="100%"/> -->
            </div>
            <div class="CompProduct-top-content-right">
              <h2>{{content[num].title1}}</h2>
              <p>{{content[num].wordP1}}</p>
            </div>
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>
    </div>
    <div class="CompProduct-cent">
      <Row>
        <Col span="2"></Col>
        <Col span="20">
          <div class="CompProduct-cent-content">
            <div class="CompProduct-cent-word">
              <h3>产品概述</h3>
              <span>{{content[num].wordP2}}</span>
              <div class="Categories-include" v-for="item of content[num].productDescription" :key="item.goodsId">
                <div class="category1" :style="item.content1?'opacity:1;':'opacity:0;'">
                  <div class="category1-1">
                    <span>{{item.content1}}</span>
                  </div>
                </div>
                <div class="category2" :style="item.content2?'opacity:1;':'opacity:0;'">
                  <div class="category2-2">
                    <span>{{item.content2}}</span>
                  </div>
                </div >
                <div class="category3" :style="item.content3?'opacity:1;':'opacity:0;'">
                  <div class="category3-3">
                    <span>{{item.content3}}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="CompProduct-cent-img">
              <img src="../../assets/img/18.png" width="100%">
            </div>
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>
    </div>
    <div class="CompProduct-bottom">
      <Row>
        <Col span="2"></Col>
        <Col span="20">
          <div class="CompProduct-bottom-content">
            <div class="CompProduct-bottom-content-left">
              <img src="../../assets/img/vector-smart-objects.png" width="100%"/>
            </div>
            <div class="CompProduct-bottom-content-right">
              <h2 :style="content[num].img?'margin-top:1.3rem':''">产品价值或优势</h2>
              <p>{{content[num].wordP3}}</p>
			  <img :src="content[num].img" width="100%">
            </div>
          </div>
        </Col>
        <Col span="2"></Col>
      </Row>
    </div>

  </div>
</template>

<script>
  export default {
    data(){
      return {
        num:this.$route.query.num,
        content:{
          "0":{
            title1:"综合运维管理系统",
            wordP1:"适用于中大型企事业单位IT运维管理、设备运维管理和信息系统运维管理等场景",
            wordP2:"符合ITIL体系的实用的运行管理体系,主体功能包括:设备管理、事件管理、告警、自动化监控和统计分析等功能。",
            productDescription:[
              {
                goodsId:0,
                content1:"设备管理",
                content2:"事件管理",
                content3:"巡检管理"
              },
              {
                goodsId:1,
                content1:"告警",
                content2:"自动化监控",
                content3:"统计分析"
              }
            ],
            wordP3:"标准的闭环运维管理流程,经历了多个大型项目的实用检验。支持设备类型定制化扩展,支持巡检定制柜化扩展,支持IT、物联感知等全类型自动监测。提供数据和业务标准接口,易于集成。"
          },
          "1":{
            title1:"物联网网关",
            wordP1:"涉及物联设备监控及管理的场景",
            wordP2:"物联网关设备，支持485、232、Net、4G/5G、NB-IOT和Lora等主流物联通讯协议，可管理可管理门禁、道闸、梯控、温感、烟感、摄像机和数据广播等物联设备和数据广播等物联设备。支持依据实际场景定制对接接口数量。标准REST API管理接口。",
            productDescription:[
              {
                goodsId:0,
                content1:"门禁",
                content2:"道闸",
                content3:"梯控"
              },
              {
                goodsId:1,
                content1:"温感",
                content2:"烟感",
                content3:"摄像机"
              }
            ],
			img:require("../../assets/img/iotG.jpg"),
            wordP3:"集中统一管理物联设备，提高企业管理物联设备的能力，降低管理维护成本，降低企业智能化信息系统建设难度和成本。帮助应用开发商把精力集中到业务研发上去。"
          },
          "2":{
            title1:"物联网综合管理平台",
            wordP1:"涉及管理、监控大量物联网关、物联设备的场景",
            wordP2:"集中、统一管理物联网关、物联设备的平台软件。主体功能包括物联网关注册、管理，物联设备注册、管理，同时对外提供物联监控和管理标准服务接口。",
            productDescription:[
              {
                goodsId:0,
                content1:"物联网关注册",
                content2:"物联网关管理",
                content3:"物联设备注册"
              },
              {
                goodsId:1,
                content1:"物联设备管理",
                content2:"物联监控",
                content3:"物联管理标准服务接口"
              }
            ],
			img:require("../../assets/img/iotP.jpg"),
            wordP3:"集中统一管理物联网关和物联设备，提高企业管理物联设备的能力，降低管理维护成本，降低企业智能化信息系统建设难度和成本。帮助应用开发商把精力集中到业务研发上去。"
          },
          "3":{
            title1:"应用集成管理平台",
            wordP1:"适用于需要对多个业务系统、智能化系统的综合管理或协同作业场景",
            wordP2:"子系统综合管理平台，第3方系统快速集成平台，主体功能包括：应用注册,子系统或第3方系统的登记。应用监测，监测子系统或第3方系统的运行状态。认证授权，统一管理子系统或第3方系统公共服务的访问认证及权限。统一门户，平台统一管理入口，包含组织结构、用户、权限、信息发布等基础管理系统。服务接入，注册子系统或第3方系统对外服务接口。服务管理，管理子系统或第3方系统对外服务接口，包括关闭、启用、状态监测和限制使用等。",
            productDescription:[
              {
                goodsId:0,
                content1:"应用注册",
                content2:"应用监测",
                content3:"认证授权"
              },
              {
                goodsId:1,
                content1:"统一门户",
                content2:"服务接入",
                content3:"服务管理"
              }
            ],
            wordP3:"辅助客户综合管理各应用，降低客户应用管理成本，提高客户应用管理能力和信息化扩展能力，奠定横向信息化建设基础。"
          },
          "4":{
            title1:"数据中台",
            wordP1:"适用于期望构建数据资产，集中管理数据，统一提供数据服务，深度开发应用数据的中大型信息化需求场景",
            wordP2:"全量采集数据，资产化管理数据，定制化开发数据应用的大数据管理平台，核心功能包括：数据采集工具,内置ETL工具，调度式自动采集数据。数据清洗，模板定制方式清理数据。数据资产管理，数据资产的定义及日常数据管理。数据应用建模,依据应用需求动态应用数据集。数据应用,依据标准流程申请并应用数据集。数据共享,标准接口提供数据共享和数据同步。",
            productDescription:[
              {
                goodsId:0,
                content1:"数据采集工具",
                content2:"数据清洗",
                content3:"数据资产管理"
              },
              {
                goodsId:1,
                content1:"数据应用建模",
                content2:"数据应用",
                content3:"数据共享"
              }
            ],
            wordP3:"帮助客户消除信息孤岛，统一数据管理，构建数据资产，奠定数据二次应用基础，为客户科学化业务管理，企业决策提供数据基础和分析工具。"
          },
		  "5":{
		    title1:"清华同方",
		    wordP1:"适用于个人娱乐和日常办公使用",
		    wordP2:"同方股份有限公司成立于1997年6月25日，同年6月27日在上海证券交易所挂牌上市。公司定位于多元化综合性科技实业孵化器，坚持走“政产学研用”结合之路，致力于中国高科技成果的转化与产业化。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"台式机",
		        content2:"笔记本",
		        content3:"周边外设"
		      },
		      {
		        goodsId:1,
		        content1:"信息安全产品",
		        content2:"",
		        content3:""
		      }
		    ],
		    wordP3:"研发能力和知识产权组合互利，是清华大学科研成果重要的孵化平台。	多元化产业布局，一站式产品及解决方案的系统集成能力。本土品牌，自主可控。"
		  },
		  "6":{
		    title1:"麒麟软件",
		    wordP1:"适用于党政、医疗、教育、企业",
		    wordP2:"银河麒麟桌面操作系统V10是图形化桌面操作系统产品。现已适配国产主流软硬件产品，同源支持飞腾、鲲鹏等国产CPU和Intel、AMD平台。河麒麟高级服务器操作系统V10是针对企业级关键业务，适应虚拟化、云计算、大数据、工业互联网时代对主机系统可靠性、安全性、性能、扩展性和实时性等需求。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"大数据",
		        content2:"云服务",
		        content3:"高性能"
		      },
		      {
		        goodsId:1,
		        content1:"易管理",
		        content2:"可靠性",
		        content3:"安全性"
		      }
		    ],
		    wordP3:"麒麟软件以安全可信操作系统技术为核心，既面向通用领域打造安全创新操作系统和相应解决方案，又面向国防专用领域打造高安全高可靠操作系统和解决方案，现已形成了服务器操作系统、嵌入式操作系统、麒麟云等产品，能够同时支持飞腾、龙芯、申威、兆芯、海光、鲲鹏等国产CPU。企业坚持开放合作打造产业生态，为客户提供完整的国产化解决方案。"
		  },
		  "7":{
		    title1:"WPS Office",
		    wordP1:"适用于党政、医疗、教育、企业",
		    wordP2:"WPS Office是由北京金山办公软件股份有限公司自主研发的一款办公软件套装，可以实现办公软件最常用的文字、表格、演示，PDF阅读等多种功能。具有内存占用低、运行速度快、云功能多、强大插件平台支持、免费提供在线存储空间及文档模板的优点。支持阅读和输出PDF（.pdf）文件、具有全面兼容微软Office97-2010格式（doc/docx/xls/xlsx/ppt/pptx等）独特优势。覆盖Windows、Linux、Android、iOS等多个平台。WPS Office支持桌面和移动办公。且WPS移动版通过Google Play平台，已覆盖超50多个国家和地区。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"文字",
		        content2:"表格",
		        content3:"演示"
		      },
		      {
		        goodsId:1,
		        content1:"内存占用低",
		        content2:"运行速度快",
		        content3:"云功能多"
		      }
		    ],
		    wordP3:"WPS Office专业版是针对企业用户提供的办公软件产品，强大的系统集成能力，如今已经与超过240家系统开发厂商建立合作关系，实现了与主流中间件、应用系统的无缝集成，完成企业中应用系统的零成本迁移。高兼容性：不仅在操作界面上与微软Office兼容，还支持直接打开和保存为微软Office格式的文档，同时，WPS Office成熟的二次开发平台，保证了与微软Office一致的二次开发接口、API接口、对象模型，兼容的VBA环境，支持COM加载插件等机制，实现了平滑迁移现有的电子政务平台、应用系统。支持XML标准：支持OOXML、UOF2.0(最新版标文通)，遵循XML标准，让政府和企业办公中的数据交换与数据检索更方便高效。"
		  },
		  "8":{
		    title1:"同有科技系列存储产品",
		    wordP1:"适用于政府、科研院所、金融、能源、教育等各行各业",
		    wordP2:"ACS 5000系列产品是同有科技基于飞腾处理器推出的成熟的中端双控商用存储产品。该系列产品在硬件、软件方面均实现了自主创新，关键部件全国产化，存储IO堆栈和管理软件均由同有自主研发，支持IP-SAN、FC-SAN、NAS。它专为用户多种关键应用及高性能应用而设计。该产品具备良好的交互性、保密性和卓越的稳定性，可以为政府、科研院所、金融、能源、教育等各行各业提供性能优异、安全可靠的存储服务。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"部件全国产化",
		        content2:"性能优异",
		        content3:"安全可靠"
		      },
		      {
		        goodsId:1,
		        content1:"交互性",
		        content2:"保密性",
		        content3:"稳定性"
		      }
		    ],
		    wordP3:"作为国内唯一上市存储企业，同有科技在大数据时代率先完成了从传统的专业存储厂商向大数据存储架构提供商的转型。专注存储行业二十余年，让同有科技能准确把握核心技术的发展趋势；基于在政府、军队军工、科研院所等行业多年的成功实践，使同有科技能研发出贴近应用的产品与解决方案；在A股市场的成功上市，为同有科技的研发投入提供了更加雄厚的资本支持。"
		  },
		  "9":{
		    title1:"锐捷系列产品",
		    wordP1:"适用于小型企业、小村小县：成本合适、能减少运维工作量、保障业务正常运转。",
		    wordP2:"轻云终端RG-CT5000L系列是云办公轻云方案的核心组成部分之一。产品采用一体化设计，配置Intel高性能标压处理器，提供4GB 或8GB DDR4内存和256GB SSD大容量固态盘存储，支持4K高清视频流畅播放及图形图像类设计软件运行。轻云终端RG-CT5000L系列采用IDV智能桌面虚拟化架构，将虚拟化层置于智能云终端中，并利用轻云管理平台集中管理，实现可视化终端管理，支持日常办公、电子阅览室、益农信息社，医联体医共体等教育、政府、医疗、企业等行业的各类场景。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"轻云终端",
		        content2:"交换机和路由器",
		        content3:"无线和物联网"
		      },
		      {
		        goodsId:1,
		        content1:"云桌面和IT运维管理",
		        content2:"智慧教室",
		        content3:"身份管理"
		      }
		    ],
		    wordP3:"轻量级云桌面架构，轻量级终端设计，终端上线快，故障恢复快，远程维护快，资产统计快，安全溯源快。"
		  },
		  "10":{
		    title1:"新一代智慧防火墙",
		    wordP1:"可广泛运用于政府机构、各类企业和组织的业务。",
		    wordP2:"新一代智慧防火墙是一款能够全面应对传统网络攻击和高级威胁的创新型防火墙产品，实现网络安全域隔离、精细化访问控制、高效的威胁防护和高级威胁检测等功能。该产品在下一代防火墙基础上超越性的集成了威胁情报、大数据分析和安全可视化等创新安全技术，并通过与网络威胁感知中心、安全管理分析中心、终端安全管理系统等的智能协同，为用户在网络边界构建数据驱动的新一代威胁防御平台。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"网络安全域隔离",
		        content2:"精细化访问控制",
		        content3:"高效的威胁防护"
		      },
		      {
		        goodsId:1,
		        content1:"高级威胁检测",
		        content2:"大数据分析",
		        content3:"安全可视化"
		      }
		    ],
		    wordP3:"（1）智慧防御一一全面防护网络攻击通过威胁情报、安全大数据和协同联动等新技术的运用，极大消除传统防御盲区，有效防御并预防病毒、漏洞利用、恶意软件、僵尸网络等主流威胁由网络边界侵入，进而实现全面、高效的业务网络防护。智慧感知——及时洞察潜在威胁基于精准的高级威胁发现能力和配套的可视化工具、平台运用，显著增强网络的全局可见性和网络威胁的感知能力， 通过实时洞察威胁态势、防御漏洞和失陷资产，及时发现网内潜伏的异常风险及高级威胁。（3）智慧管理一一提升响应处置效率基于智能化的人机协同设计及配套的管理分析平台，持续助推用户的安全运营落地，大幅降低规模化部暑用户的运维管理成本，避免误配置风险，并显著提升快速响应和处置的能力。"
		  },
		  "11":{
		    title1:"上网行为管理与审计系统",
		    wordP1:"可广泛运用于政府机构、各类企业和组织的业务。",
		    wordP2:"智能流量管理系统是基于应用层的专业流量分析和管控系统。独有的XAI 专利技术，保证应用识别精准；基于时间、VLAN、用户、应用、数据流向等条件，通过监控网络流量、分析流量行为、设置管理策略，实现全面的智能流量分析和管理，有效进行问题定位和解决；通过智能化的应用选路技术，解决链路负载不均，应用分担不合理等问题",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"XAI 专利技术",
		        content2:"监控网络流量",
		        content3:"分析流量行为"
		      },
		      {
		        goodsId:1,
		        content1:"设置管理策略",
		        content2:"智能化的应用选路技术",
		        content3:""
		      }
		    ],
		    wordP3:"（1）透明感知网络状态，降低运维负担智能流量管理系统能清晰呈现用户网络的流量状况，网络中的应用种类及每种流量所占的带宽资源的大小， 全面感知网络状态，高效减轻网络运维工作量。（2）限制无关应用带宽，降低带宽投资智能流量管理系统能够有效控制P2P等占用带宽的无关应用，保证按需分配，做到带宽使用的合理化，帮助企业用户降低网络带宽投资。（3）保障关键应用带宽，提高业务质量智能流量管理系统可以细致划分网络带宽，保证关键业务的稳定运行。独有的应用级体验质量技术（QoE）可对关键业务的质量进行分析，协助管理员优化管控策略，最终提升关键业务服务质量。"
		  },
		  "12":{
		    title1:"终端安全管理系统",
		    wordP1:"可广泛运用于政府机构、各类企业和组织的业务；",
		    wordP2:"终端安全管理系统（简称“天擎”）是注重实效的一体化终端安全解决方案，通过“体系化防御、数字化运营”方法，帮助政企客户准确识别、保护和监管终端，并确保这些终端在任何时候都能可信、安全、合规地访问数据和业务。天擎基于奇安信全新的“川陀”终端安全平台构建，集成高性能病毒查杀、漏洞防护、主动防御引擎，深度融合威胁情报、大数据分析和安全可视化等创新技术，通过系统合规与加固、威胁防御与检测、运维管控与审计、终端数据防泄漏、统一管理与运营等功能，帮助政企客户构建持续有效的终端安全能力。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"体系化防御",
		        content2:"数字化运营",
		        content3:"高性能病毒查杀"
		      },
		      {
		        goodsId:1,
		        content1:"高级威胁检测",
		        content2:"深度融合威胁情报",
		        content3:"终端数据防泄漏"
		      }
		    ],
		    wordP3:"（1）能力一体，简化管理采用一体化设计思路，即平台一体化、功能一体化、管理一体化，大幅降低终端安全体系建设、运行、扩展的复杂性。（2）防御闭环，风险可控对安全威胁进行闭环防御，即预防、防护、检测、响应，有效防御各种已知、未知安全威胁，大幅降低安全风险。（3）管控到位，合法合规对资产、用户、行为、数据等进行全生命周期的精细化管控，确保终端符合内外部的相关要求，真正做到合法合规。（4）效果清晰，按需提升提供数字化运营方法、可视化运营工具，实时呈现终端安全效果，针对性分析当前不足，便于按需提升终端安全系数。"
		  },
		  "13":{
		    title1:"威胁检测与分析系统",
		    wordP1:"可广泛运用于政府机构、各类企业和组织的业务；",
		    wordP2:"威胁监测与分析系统（天眼）是以攻防渗透和数据分析为核心竞争力，聚焦威胁检测和响应，为客户提供安全服务与产品解决方案。天眼基于网络流量和终端EDR日志，运用威胁情报、规则引擎、文件虚拟执行、机器学习等技术，精准发现网络中针对主机与服务器的已知高级网络攻击和未知的新型网络攻击的入侵行为，利用本地大数据平台对流量日志和终端日志进行存储和查询，结合威胁情报和攻击链分析对事件进行分析、研判和回溯，同时结合边界NDR、终端EDR以及自动化编排处置可以及时的阻断威胁。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"终端EDR日志",
		        content2:"运用威胁情报",
		        content3:"规则引擎"
		      },
		      {
		        goodsId:1,
		        content1:"文件虚拟执行",
		        content2:"机器学习",
		        content3:"自动化编排处置"
		      }
		    ],
		    wordP3:"（1）高级威胁的精准检测与传统的安全检测方案相比，天眼系统可以快速并精准发现网络威胁攻击，准确率高，误报率低。（2）重大安全事件的快速响应基于威胁情报的上下文，天眼系统可以帮助安全运营人员发现、研判和处置重大安全事件如：永恒之蓝、APT事件、NotPetya、BlueKeep、Sodinokibi。（3）网络攻击的回溯和分析天眼系统还原和存储网络流量的元数据，可以帮助用户回溯已经发生网络攻击行为，分析攻击路径、受感染面和信息泄露状况。（4）满足新等保的合规要求天眼系统满足了新等保2.0对网络攻击检测和分析要求，特别是针对新型网络攻击和APT攻击。"
		  },
		  "14":{
		    title1:"安全接入网关系统（SSL VPN）",
		    wordP1:"面向政府、企业、金融、能源、运营商等行业客户；",
		    wordP2:"安全接入网关系统(SSL VPN)推出的，解决客户通过互联网使用电脑及智能终端远程办公、专网环境办公等场景的安全接入问题，实现客户5A级办公。安全接入网关系统在满足客户的身份安全、传输加密、访问授权、日志追溯等多种安全需求基础上，针对 BYOD 及 CYOD 等移动办公场景，提供统一的安全办公接入入口、门户式单点登录、应用 APP安全加固、移动应用数据安全，从而为客户提供“一站式”安全移动办公解决方案。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"实现客户5A级办公",
		        content2:"统一的安全办公接入",
		        content3:"门户式单点登录"
		      },
		      {
		        goodsId:1,
		        content1:"应用 APP安全加固",
		        content2:"移动应用数据安全",
		        content3:"“一站式”安全移动办公"
		      }
		    ],
		    wordP3:"（1）办公移动化帮助企业员工实现任意时间、任意地点，安全可靠远程办公。（2）权责划分结合公司管理架构，做到精细化控制，为不同职责员工匹配不同业务应用。（3）助力移动信息化平台搭建提供业内经典的移动办公解决方案，从终端（PC端、移动端）层面、身份层面、到链路层面、再到应用层面，实现“一体化”整体解决方案。（4）满足合规要求符合移动信息化安全建设规范，满足国产化、两办36号文以及等保要求。"
		  },
		  "15":{
		    title1:"统一服务器安全管理系统",
		    wordP1:"面向政企用户的虚拟化、云、数据中心环境；",
		    wordP2:"统一服务器安全管理系统保护用户的服务器、虚拟机、云主机、容器等IT基础设施安全的产品。通过网络微隔离、多引擎协同文件防护、主机网络入侵防御等防护方式，消除工作负载中的恶意扫描、漏洞攻击、病毒感染及横向传播等安全威胁，结合安全态势感知及可视化能力，对安全风险进行统一分析和展现。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"保护用户的IT基础设施",
		        content2:"网络微隔离",
		        content3:"多引擎协同文件防护"
		      },
		      {
		        goodsId:1,
		        content1:"主机网络入侵防御",
		        content2:"消除工作负载中的恶意扫描",
		        content3:"安全态势感知"
		      }
		    ],
		    wordP3:"（1）云内安全合规系统建设、运营、 维护各阶段满足用户云等保合规需求， 云上安全解决方案与云等保要求对应， 解决用户实际安全问题， 满足云安全长期规划建设需求。（2）安全可视、可管、可控通过本地＋云端协同、精细严格的防护能力、实时全面的日志分析， 提供安全风险从发现·响应·处置完整闭环的解决方案。（3）管理低成本、 操作更便捷硬件服务器、 虚拟化并行一个管理平台， 通过批量导入、统一策略和集中运维， 使虚拟机安全运维管理变得简单易操作， 显著提高安全投资利用率、回报率。"
		  },
		  "16":{
		    title1:"服务器安全管理系统（云锁）",
		    wordP1:"面向政企用户的虚拟化、云、数据中心环境；",
		    wordP2:"云锁服务器安全管理系统依据CWPP（云工作负载保护平台）框架打造，基于服务器轻量级Agent，能有效保护服务器操作系统及应用，通过资产清点、基线检查、漏洞检测、虚拟补丁、应用防护（RASP、IN-APP waf）、系统加固、webshell&病毒查杀、攻击溯源等功能，有效抵御黑客攻击和恶意代码，实现资产发现-漏洞检测-漏洞利用防护的闭环管理，打造服务器事前防御、事中对抗、事后溯源的内生安全能力。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"资产清点",
		        content2:"基线检查",
		        content3:"漏洞检测"
		      },
		      {
		        goodsId:1,
		        content1:"虚拟补丁",
		        content2:"应用防护",
		        content3:"系统加固"
		      }
		    ],
		    wordP3:"（1）服务器主机合规满足等保合规中关于主机上线前安全检查的要求；（2）防漏扫探测可防止主流的漏扫工具对服务器的弱点进行扫描及探测；（3）主机日常防护满足企业服务器防勒索/挖矿、弱口令治理、端口/进程外网暴露、补丁空窗期等安全问题；（4）HW多得分采用服务器入侵行为分析与攻击路径溯源技术，可阻止服务器的异常登陆或操作，并以图形化的方式完整还原攻击路径，可为防守方夺得防护与溯源分数；（5）业务“零”影响无感化部署与防御，在保证业务优先的情况下进行监测与防护。"
		  },
		  "17":{
		    title1:"安全SD-WAN",
		    wordP1:"适用于多分支机构、数据中心互联、混合云等场景",
		    wordP2:"安全SD-WAN以网络即服务（NaaS）的方式，不仅解决网络运维成本高、广域组网复杂等网络问题，同时针对广域网及内网数据日益严峻的安全风险，提供“端·网·云”一体的端到端安全防护能力，通过灵活便捷、按需定制的网络连接，弹性部署的安全能力，数据驱动的网络及安全策略决策支持，让网络更安全，让安全更智能。 安全SD-WA N由安全网络路由网关系统、安全网络管控平台组成，可以与虚拟化部署的 NGFW、 ICG、lPS等安全能力集。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"端到端安全防护能力",
		        content2:"按需定制的网络连接",
		        content3:"弹性部署的安全能力"
		      },
		      {
		        goodsId:1,
		        content1:"数据驱动的网络",
		        content2:"安全策略决策支持",
		        content3:""
		      }
		    ],
		    wordP3:"（1）提升业务体验基于自动化部署的智能特性，奇安信网神安全SD-WAN可将业务上结时间 (TTM）缩短至分钟级。同时，通过对重要业务的质量保证，搜需优选应用路径，系统和链路高可用保障，使得访问业务的体验得到显著提升。（2）保障业务安全通过端到端加密、传送隔离、深度检测等技术的运用，奇安信网神安全SD-WAN可提供基于用户、业务等多维度的身份认证和权限控制，并实现网络攻击防护、入侵防御、病毒防护、URL过滤，在构建安全可信企业网络的同时全面确保业务安全（3）降低TOC成本安全SD-WAN通过零配置上线、自动化运维、可视化管理可显著提高运维效率，从而大幅降低全网运维成本。此外，通过提升网络的高可用和高质量服务，可降低企业广域网络的组网投资，从而降低企业网络的TOC成本。"
		  },
		  "18":{
		    title1:"数据库审计与防护系统",
		    wordP1:"可广泛运用于政府机构、各类企业和组织的业务；",
		    wordP2:"数据库安全审计与防护系统支持硬件盒子和软件形态的灵活部署方式，解析端口镜像过来的报文信息，记录用户访问数据库行为的记录、汇总分析所有的用户操作行为，通过大数据分区搜索技术提供高效检索审计记录能力，快速定位事件原因，帮助用户事后生成合规报告、提供有效电子取证信息，用于数据安全事故的追根溯源，实现加强内外部数据库网络行为的监控与审计，提高数据资产安全。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"大数据分区搜索技术",
		        content2:"高效检索审计记录",
		        content3:"快速定位事件原因"
		      },
		      {
		        goodsId:1,
		        content1:"提供有效电子取证信息",
		        content2:"据库网络行为的监控与审计",
		        content3:"提高数据资产安全"
		      }
		    ],
		    wordP3:"（1）满足合规性要求系统为核心数据库系统提供了独立的审计解决方案，有助于完善组织的IT内控体系，从而满足各种合规性要求，并且使组织能够顺利通过IT审计。（2）减少核心资产破坏与泄露系统能够加强对数据库访问行为的审计，针对拖库、撞库、删库等高危操作进行实时告警，从而有效地减少对核心信息资产的破坏和泄露（3）追踪溯源便于事后追查原因与界定责任，负责运维的部门通常拥有数据库管理系统的最高权限(掌握DBA账号的口令)，因而也承担着很高的风险(误操作或者是个别人员的恶意破坏)。系统能够帮助客户进行事后追查原因与界定责任。"
		  },
		  "19":{
		    title1:"运维安全管理与审计系统（堡垒机）",
		    wordP1:"可广泛运用于政府机构、各类企业和组织的业务；",
		    wordP2:"运维审计系统（俗称 “堡垒机”）：是采用新一代智能运维技术框架，基于认证、授权、访问、审计的管理流程设计理念，实现对企事业IT中心的网络设备、数据库、安全设备、主机系统、中间件等资源统一运维管理和审计；通过集中化运维管控、运维过程实时监管、运维访问合规性控制、运维过程图形化审计等功能，为企事业IT中心运维构建一套事前预防、事中监控、事后审计完善的安全管理体系。广泛满足政府、金融、能源、电力、、医疗、央企等行业的运维审计规范要求。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"资源统一运维管理和审计",
		        content2:"集中化运维管控",
		        content3:"运维过程实时监管"
		      },
		      {
		        goodsId:1,
		        content1:"运维访问合规性控制",
		        content2:"运维过程图形化审计",
		        content3:""
		      }
		    ],
		    wordP3:"（1）统一身份认证规范了运维访问的统一入口，使账号管理更加简单有序。（2）事后追责审计提高运维故障处理效率，提供精准的责任鉴定和事件追溯。（3）统一资产管理有效对资产的监控和管理，避免安全损失，保障企业效益。（4）提升运维效率提高了IT运维部工作效率，降低工作复杂度。（5）降低安全风险有效阻止误操作，滥操作，以及越权访问造成系统破坏。（6）满足合规监管满足各组织合规要求，使组织能顺利通过IT内审。"
		  },
		  "20":{
		    title1:"MG（户内小间距产品）",
		    wordP1:"MG可满足，智慧城市，数据中心，平安城市，能源电力，军事指挥，公安/安防/监控，等领域。",
		    wordP2:"MEGA在古英文解释中含有“伟大的”意思，在现代MEGA则表示相机光感值“百万”像素，1Mega即1百万，MG作为小间距产品，十分契合“百万”像素的设定，同时Mega还有优秀的含义，也代表了产品的品质、设计和应用所达到的标准。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"良好的贴片位置容许度",
		        content2:"良好的扭转强度",
		        content3:"良好的耐震性"
		      },
		      {
		        goodsId:1,
		        content1:"降低错位嵌合时对焊脚的应力",
		        content2:"防止出现焊锡裂痕",
		        content3:""
		      }
		    ],
		    wordP3:"MG在某一路供电电源故障的情况下，依然可以保证显示屏正常运行。采用精确色彩管理系统，在LED控制系统对视频解码后，添加二次过滤显示算法，对显示屏每一个发光二极管进行逐点16位颜色校正。通过构造非线性校正曲线和色坐标变换系数矩阵实现了显示效果的不断改善，各项重要指标如色彩还原性、色温调节范围、亮度均匀性、色度均匀性、刷新率、换帧频率等，均符合广电级标准。LED显示屏采用高品质黑表面LED灯，提高发光亮度，同时降低屏幕黑色时的亮度。公司独有的黑色面罩处理技术，让屏幕对比度获得极大再提升。"
		  },
		  "21":{
		    title1:"VED(室内产品系列)",
		    wordP1:"适用于学校、报告厅、办公室等",
		    wordP2:"",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"全新外观设计",
		        content2:"独立模块单元",
		        content3:"打破传统安装方式"
		      },
		      {
		        goodsId:1,
		        content1:"重新定义产品精度",
		        content2:"隐藏式吸盘设计",
		        content3:"专用的拆卸工具"
		      }
		    ],
		    wordP3:"VED更换模组，自动发送回读校正数据，可设置衰减系数，使备品模组不存在色差。超高刷新频率：采用特殊色差校正技术，显示效果极佳，使图文更清晰，动画效果流畅，无动态马赛克现象。现场更换模组系统自动智能读取模组中的校正数据，在可视范围内观看区域更大，眼内呈现信息更多，图像任意细节清晰可见。独特的面罩设计：独特的LED周边填充设计，屏幕表面不反光，色彩更柔和，观看更舒服。"
		  },
		  "22":{
		    title1:"TVF",
		    wordP1:"适用于学校教室、办公大楼、会议大厅、展厅、体育场馆等",
		    wordP2:"TVF长27.3吋 16:9设计，显示单元采用镁合金箱体设计，一次性整体压铸，后盖采用镁合金设计，单元模组采用镁合金底壳设计。具有防电磁辐射，抗冲击，无风扇，防尘、静音设计。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"镁合金设计",
		        content2:"防电磁辐射",
		        content3:"抗冲击"
		      },
		      {
		        goodsId:1,
		        content1:"无风扇",
		        content2:"防尘",
		        content3:"静音设计"
		      }
		    ],
		    wordP3:"箱体自带LCD液晶信息显示屏，可显示屏幕工作状态。每块屏幕具备单独调校伽马设计。磁力触发主动式前维护系统，实现快达5秒的前维护，模组还原精度更高。可前拆卸，可后维护，适用更多安装环境；可灵活选择，电源冗余备份，满足7*24小时不间断工作。智能模组设计，可独立存储ESM数据，校正数据，维修快捷；可独立存储校正数据，使维修更换不存在色差;用人机交互LCD屏设计，为维修，调试提供方便;隐藏式设计，保证箱体之间良好的接触以及屏体背部美观整洁."
		  },
		  "23":{
		    title1:"IT自动化监测系统",
		    wordP1:"适用于拥有独立IT机房的单位，IT环境运维保障。",
		    wordP2:"IT自动化检测系统是依靠SNMP协议或厂商私有协议，实时监控服务器、存储设备、虚拟化平台、交换机、路由器、防火墙、操作系统和中间件等IT设备或资源健康状况和运行状态，分类分级预警异常。同时提供应用系统运行状态、访问压力等的实时监测。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"",
		        content2:"",
		        content3:""
		      },
		      {
		        goodsId:1,
		        content1:"",
		        content2:"",
		        content3:""
		      }
		    ],
			img:require("../../assets/img/itms.png"),
		    wordP3:"支持海量设备监测；支持自动发现IT资源；支持自动发现网络拓扑结构；支持主流厂商私有协议接入，非主流产品支持定制开发；支持异常事件流程式处理（支持自定义流程）；支持终端非法接入网络预警；支持IT资源健康报告。支持邮件或短信等方式自动异常告警。提供资源共享标准接口提供监测结果共享标准接口应用场合：拥有独立IT机房的单位，IT环境运维保障。"
		  },
		  "24":{
		    title1:"运维管理系统",
		    wordP1:"适用于场馆设备维护、桌面IT运维、机房运维和应用系统运维等运维服务管理。",
		    wordP2:"运维管理系统统一管理客户资源（设备、机构和人员等），标准化运维工作，跟踪运维痕迹，辅助客户管理、评价运维服务团队。主体功能包括：资源管理、值班管理、巡检管理、运维巡检、工单管理、告警管理、日常统计和运维报告等。支持集成“IT监测系统”、“动环监系统”、“安全检测系统”和“日志监测系统”等自动化监控系统，实现事前、事中和事后运维管理的全生命周期管理。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"",
		        content2:"",
		        content3:""
		      },
		      {
		        goodsId:1,
		        content1:"",
		        content2:"",
		        content3:""
		      }
		    ],
			img:require("../../assets/img/emos.jpg"),
		    wordP3:"支持客户自定义资产结构、资源关系管理；支持移动运维（巡检、告警、工单和评价等）；支持告警分类、分级管理；支持重点工单标记管理；支持工单流程自定义；支持延期、转单、挂起等工单办理场景；可定义扩展可视化运维（基于平面图/3D仿真模型或地图的可视化运维）。提供资源共享标准接口提供告警共享标准接口提供工单共享标准接口。"
		  },
		  "25":{
		    title1:"基础管理平台",
		    wordP1:"适用于企事业单位信息化建设。",
		    wordP2:"基础管理平台是信息化建设基础功能模块的统一管理平台，是信息化建设基础数据、基础功能组件。主体功能包括：统一门户、设备（资产）管理、组织结构管理、人员管理、功能权限管理、资源权限管理、认证中心、信息发布、元数据管理、任务管理、流程管理、工作台和企业微信等。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"",
		        content2:"",
		        content3:""
		      },
		      {
		        goodsId:1,
		        content1:"",
		        content2:"",
		        content3:""
		      }
		    ],
			img:require("../../assets/img/bpm.jpg"),
		    wordP3:"支持Linux/Windows/Docker等部署环境；Web系统，基于JEE平台，微服务架构实现；提供标准接口供第3方接入；提供消息服务机制订阅数据；"
		  },
		  "26":{
		    title1:"动力环境监测系统",
		    wordP1:"适用于机房动环监测、实验室环境监测、仓库环境监测和场馆环境监测等。",
		    wordP2:"动力环境监测系统依托电压/电流仪、温度感应器、烟物探测器、水浸传感器和气味探测器等环境感知设备，实时监控环境状况；通过协议或接口对接UPS电源、精密空调、新风系统、门禁和视频监控设备，实时监控其运行状态，远程操控设备；发现异常自动报警或联动应急的监测管理系统。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"",
		        content2:"",
		        content3:""
		      },
		      {
		        goodsId:1,
		        content1:"",
		        content2:"",
		        content3:""
		      }
		    ],
		  	img:require("../../assets/img/pems.jpg"),
		    wordP3:"支持主流物联协议管理物联感知设备；支持用户自选物联设备厂商和型号；支持采集模块分布式部署，应对海量感知设备场景；支持邮件或短信等方式自动异常告警；支持异常告警时，视频监控设备自动播放跟踪；支持可视化展示监测情况。提供资源共享标准接口提供监测结果共享标准接口"
		  },
		  "27":{
		    title1:"边缘计算网关",
		    wordP1:"系统采用B/S架构，部署在服务器、视频解析; 盒子，获取前端摄像机或存储设备的视频流，在浏览器进行人员违章及环境异常识别处理。",
		    wordP2:"物联网、5G等新技术的发展，越来越多的设备实现互联，海量设备产生的数据呈指数级增长，高并发的数据量导致网络带宽的限制，为提高数据传输及处理的实时性，同时提升客户的体验感及安全性，近边端的网关设备显得尤为重要。边缘计算网关可以为客户解决网络条件差，传输成本高昂、数据传输实时性差、数据安全性不理想的问题，并通过自研的运维管理平台实现大规模部署的远程监控和管理。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"",
		        content2:"",
		        content3:""
		      },
		      {
		        goodsId:1,
		        content1:"",
		        content2:"",
		        content3:""
		      }
		    ],
		  	img:require("../../assets/img/edge.jpg"),
		    wordP3:"基础检测项目：烟火检测、烟雾检测、值班人员离岗检测、消防通道（室内、室外）占用检测；可选检测项目：电瓶车检测、高危区域人员检测、消防器材检测、佩戴安全帽检测；数据采集监测包括：液位数据采集监测、液压数据采集检测、温湿度数据采集检测等。直流12V供电，12V掉电检测；4口千兆交换，带端口管控功能，可配256G-1T大容量"
		  },
		  "28":{
		    title1:"视频网关",
		    wordP1:"适用于企事业单位信息化建设。",
		    wordP2:"采用高算力ARM内核处理器，周边配套高实时性电源管理系统和端口控制，保证整个系统在死机或温度超常时重启或暂时关机保护。可快速接入海康、大华等主流品牌摄像机，广泛适用于各种标准码流的社会资源接入场合，如雪亮工程、智慧校园、小区等，通过云平台可对网关进行统一的维护管理。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"",
		        content2:"",
		        content3:""
		      },
		      {
		        goodsId:1,
		        content1:"",
		        content2:"",
		        content3:""
		      }
		    ],
			img:require("../../assets/img/videG.jpg"),
		    wordP3:"视频接入网关视频点播--支持pc客户端实时视频浏览;ONVIF搜索--支持扫描ONVIF设备列表、双重加密—保障系统安全;中心管理--支持接入平台统一管理状态显示—通道状态一目了然;全网通--支持电信、移动、联通的4G模式（4G版本）、设备状态—实时显示与云服务的连接状态云平台平台可以对网关授权日期、路数授权进行控制管理 平台网关信息同步; 通道信息展示; 通道统一管理视频点播; 网关设备自定义分组;用户统一管理第三方接入，为第三方提供SDK接口，方便快速集成；12V供电，12V掉电检测；2路RS485，为标准Modbus协议；5口千兆交换，带端口管控功能；1个USB3.0接口； 3路开关量输入，1路开关量输出； 运行、网络、状态指示； 恢复默认按钮；"
		  },
		  "29":{
		    title1:"智慧园区",
		    wordP1:"适用于中大型医药园、物流园、工业园等",
		    wordP2:"以“中间统一管理中台”为基础，集成智慧通行、一卡/码/机/脸通、视频会议、消安一体化、环境能耗监测、智慧物流等应用，构建智慧园区综合管理系统。辅助客户实现：信息化统一监控、管理；生产运行状态、能源消耗、环保监测、污水处理、安全防护、消防实时监控；生产流程和数据采集电子化和实时化；智慧通行；智慧物流；数据集中采集和统一管理；智能运维保障。",
		    productDescription:[
		      {
		        goodsId:0,
		        content1:"",
		        content2:"",
		        content3:""
		      },
		      {
		        goodsId:1,
		        content1:"",
		        content2:"",
		        content3:""
		      }
		    ],
		  	img:require("../../assets/img/zhyqC.jpg"),
		    wordP3:"自带标准化的智慧通行、能源环境监测、智能综合运维；可便捷集成各业务领域第3方应用系统标准接口和消息方式，为第3方应用提供基础设备、基础数据服务。标准接口和消息方式，接入第3方应用系统业务数据，并流程式完成数据资产管理。提供横向数据挖掘、分析功能。"
		  },
        },

      }
    }
  }

</script>

<style lang="less" scoped="scoped">
  .CompProduct{
    .CompProduct-top{
      background-size: 100% 113%;
      background-image: url(../../assets/img/banner.png);
      background-repeat: no-repeat;
      padding-top: 1rem;
      padding-left: 0.5rem;
      .CompProduct-top-content{
        display: flex;
        .CompProduct-top-content-left{
          flex: 1.4;
        }
        .CompProduct-top-content-right{
          flex: 3;
          text-align: right;
          padding-right: 0.5rem;
          color: #FFFFFF;
          h2{
            margin-top: 1rem;
            margin-bottom: 0.5rem;
             font-family: SourceHanSansCN-Medium;
             font-size: 30px;
             font-weight: normal;
             font-stretch: normal;
             line-height: 0px;
             letter-spacing: 0px;
             color: #ffffff;
          }
          p{
            margin-bottom: 1.5rem;
             font-family: MicrosoftYaHeiLight;
             font-size: 12px;
             font-weight: normal;
             font-stretch: normal;
             line-height: 33px;
             letter-spacing: 0px;
             color: #ffffff;
          }
        }
      }
    }
    .CompProduct-cent{
      background-color: #f4f5fa;
      padding-top: 1rem;
      padding-left: 0.5rem;
      padding-right: 0.5rem;
      .CompProduct-cent-content{
        display: flex;
        margin-bottom: 0.5rem;
        .CompProduct-cent-word{
          text-align: left;
          flex: 2.5;
          padding-right: 2rem;
          h3{
             font-family: SourceHanSansCN-Regular;
             font-size: 24px;
             font-weight: normal;
             font-stretch: normal;
             line-height: 0px;
             letter-spacing: 0px;
             color: #333333;
            margin-top: 0.5rem;
            margin-bottom: 0.5rem;
          }
          span{
             font-family: SourceHanSansCN-Light;
             font-size: 11px;
             font-weight: normal;
             font-stretch: normal;
             // line-height: 55px;
             letter-spacing: 0px;
             color: #253554;
          }
          .Categories-include{
            margin-top: 0.2rem;
            display: flex;
            text-align: center;
            .category1{
              flex: 1;
              padding: 5px;
              .category1-1{
                height: 0.5rem;
                background-image: linear-gradient(#f4f5fa, #fdfdfd);
                line-height: 0.5rem;
                span{
                   font-family: SourceHanSansCN-Regular;
                   font-size: 13px;
                   font-weight: normal;
                   font-stretch: normal;
                   line-height: 24px;
                   letter-spacing: 0px;
                   color: #46506b;
                }
              }
            }
            .category2{
              flex: 1;
              padding: 5px;
              .category2-2{
                height: 0.5rem;
                background-image: linear-gradient(#f4f5fa, #fdfdfd);
                line-height: 0.5rem;
                span{
                   font-family: SourceHanSansCN-Regular;
                   font-size: 13px;
                   font-weight: normal;
                   font-stretch: normal;
                   line-height: 24px;
                   letter-spacing: 0px;
                   color: #46506b;
                }
              }
            }
            .category3{
              flex: 1;
              padding: 5px;
              .category3-3{
                height: 0.5rem;
                background-image: linear-gradient(#f4f5fa, #fdfdfd);
                line-height: 0.5rem;
                span{
                   font-family: SourceHanSansCN-Regular;
                   font-size: 13px;
                   font-weight: normal;
                   font-stretch: normal;
                   line-height: 24px;
                   letter-spacing: 0px;
                   color: #46506b;
                }
              }
            }
          }
        }
        .CompProduct-cent-img{
          flex: 1;
        }
      }
    }
    .CompProduct-bottom{
      .CompProduct-bottom-content{
        display: flex;
        .CompProduct-bottom-content-left{
          flex: 1;
          padding: 1rem 1rem 1rem 0.5rem;
        }
        .CompProduct-bottom-content-right{
          flex: 2;
          padding-right: 0.5rem;
          h2{
            text-align: right;
            margin-top: 2.3rem;
            margin-bottom: 0.4rem;
             font-family: SourceHanSansCN-Regular;
             font-size: 24px;
             font-weight: normal;
             font-stretch: normal;
             line-height: 0px;
             letter-spacing: 0px;
             color: #333333;
          }
          p{
              font-family: SourceHanSansCN-Light;
              font-size: 11px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 20px;
              letter-spacing: 0px;
              color: #253554;
          }

        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/product-center-contet/CompProduct.vue